import { Details, ItemInput } from '../../gql/graphql';

export const getNonLeasableItems = (orderDetails: Details): ItemInput[] => {
  let nonLeasableItems: ItemInput[] = [];
  orderDetails.items?.forEach((item) => {
    if (!item.isLeaseable) {
      nonLeasableItems.push(item);
    }
  });
  return nonLeasableItems;
};
